interface rateProps {
  numerator: number;
  denominator: number;
}

export const rateOfChange = ({ numerator, denominator }: rateProps): number => {
  if (numerator <= 0 || denominator <= 0) return 0;
  return Math.round((numerator / denominator) * 100);
};
